/* eslint-disable */
import en_US from './en_US.json'
import zh_CN from './zh_CN.json'

export default {
  en_US,
  zh_CN,
}
export {
  en_US,
  zh_CN
}



// WEBPACK FOOTER //
// ./src/languages/index.js